import { FetchAPI } from './auth-service';

const fields = [
    {
        variable: 'name',
        hidden: false,
        headerName: 'BT Job',
        field: 'name',
        type: 'string',
    },
    {
        variable: 'owner',
        hidden: false,
        headerName: 'Owner',
        field: 'owner',
        type: 'string',
    },
    {
        variable: 'activity',
        hidden: false,
        headerName: 'Last Activity',
        field: 'data.activity',
        type: 'string',
    },
    {
        variable: 'sensor',
        hidden: false,
        headerName: 'BT Sensor',
        field: 'sensor',
        type: 'string',
    },
    {
        variable: 'status',
        hidden: false,
        headerName: 'Status',
        field: 'status',
        type: 'string',
    },
    {
        variable: 'error',
        hidden: false,
        headerName: 'Message',
        field: 'error',
        type: 'string',
    },
    {
        variable: 'description',
        hidden: false,
        headerName: 'Job Description',
        field: 'description',
        type: 'string',
    },
    {
        variable: 'results',
        hidden: false,
        headerName: 'Job Results',
        field: 'results',
        type: 'string',
    },
    {
        variable: 'actions',
        hidden: false,
        headerName: 'Actions',
        field: 'actions',
        type: 'string',
    },
];

class BacktestingDataService {
    constructor () {
        // we only need one of these
        if (!BacktestingDataService.instance) {
            BacktestingDataService.instance = this;
        }
        this.searchPlaceholder = 'Search Backtesting Jobs';
        this.fields = fields;

        this.createJob = (data) => {
            return FetchAPI({
                method: 'POST',
                url: 'backtesting/jobs',
                body: data,
            });
        };

        this.getJob = (name) => {
            return FetchAPI({
                method: 'GET',
                url: `backtesting/jobs/${name}`,
            });
        };

        this.getJobs = () => {
            return FetchAPI({
                method: 'GET',
                url: 'backtesting/jobs',
            });
        };

        this.updateJob = (data) => {
            return FetchAPI({
                method: 'PUT',
                url: 'backtesting/jobs',
                body: data,
            });
        };

        this.cancelAllJobs = () => {
            return FetchAPI({
                method: 'PUT',
                url: 'backtesting/jobs/-cancel',
            });
        };

        this.cancelJob = (name) => {
            return FetchAPI({
                method: 'PUT',
                url: `backtesting/jobs/${name}/-cancel`,
            });
        };

        this.pushJob = (name) => {
            return FetchAPI({
                method: 'PUT',
                url: `backtesting/jobs/${name}/-push`,
            });
        };

        this.deleteJob = (name) => {
            return FetchAPI({
                method: 'DELETE',
                url: `backtesting/jobs/${name}`,
            });
        };

        this.getBTSensorUpgradeSchedule = (group) => {
            return FetchAPI({
                method: 'GET',
                url: `backtesting/upgrades/schedule/${group}`,
            });
        };

        this.updateBTSensorUpgradeSchedule = (group, data) => {
            return FetchAPI({
                method: 'POST',
                url: `backtesting/upgrades/schedule/${group}`,
                body: data,
            });
        };

        this.getSavedSearches = () => {
            try {
                let searches = localStorage.getItem('savedSearches_backtesting') || '[]';
                if (searches.length < 1) searches = '[]';
                return JSON.parse(searches);
            } catch (err) {
                console.log('getSavedSearches error', err);
                return [];
            }
        };

        this.saveSearch = (str) => {
            if (!str || !str.length) return;
            const searches = this.getSavedSearches();
            const i = searches.findIndex(s => s === str);
            if (i >= 0) searches.splice(i, 1);
            searches.unshift(str);
            searches.splice(5);
            localStorage.setItem('savedSearches_backtesting', JSON.stringify(searches));
        };

        // backtesting policies that get auto pushed as part of the backtesting job
        this.policies = { suricata_rules: true, bro_ti: true, zeek_indicators: true };

        return BacktestingDataService.instance;
    }
}

const BacktestingService = new BacktestingDataService();

export {
    BacktestingService as default,
    fields,
};
